/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.professional-development.credit-types'},
});

const CreditTypesItem = () => (
  <RouteLinkItem
    route="midas/settings/professional-development/credit-types"
    title={messages.title}
  />
);

export default CreditTypesItem;
